import axios from '@/libs/axios'

export class ReportSetting {

    static async getSetting(reportName) {

        return new Promise((resolve, reject) => {
            axios.get(`user/getReportNotifications`)
                .then(res => {
                   
                    const reportData = res.data.reports.filter((r) => r.type == reportName)
                    if (reportData[0]) {
                        resolve(reportData[0])
                    }
                })
                .catch(reason => reject(reason.response))
        })
    }


     
  
    static async   setSettings(reportName,data) {
      
        let formatedData = {
          type: reportName,
          ...data,
        }
        return new Promise((resolve, reject) => {
            axios.post(`user/setReportNotifications/reports`,formatedData)
              .then(res => resolve(res.data))
              .catch(reason => reject(reason.response))
          })
      }


     
  

}